import routes from "@/routes/routes.json"
export const forceLogout = () => {
  sessionStorage.clear();
  localStorage.clear()
  sessionStorage.removeItem("bearer_token");
  sessionStorage.removeItem("user")
  window.location.href = routes.login;
};
